import { render, staticRenderFns } from "./excitingRecording.vue?vue&type=template&id=bf2ad60e&scoped=true"
import script from "./excitingRecording.vue?vue&type=script&lang=js"
export * from "./excitingRecording.vue?vue&type=script&lang=js"
import style0 from "./excitingRecording.vue?vue&type=style&index=0&id=bf2ad60e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2ad60e",
  null
  
)

export default component.exports